
import restService from "@/services/restService";
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
@Component({
  components: {},
})
export default class SsnEditor extends Vue {

  ssn: string = "";
  originalSsn = "";
  showSsn = false;
  valid = true;
  rules: any = {
    isValid: (value) => {
      return !!this.isValidSsn(value) || this.$i18n.translate("validation.rules.ssn", "Check social security number")
    }
  };
  @Prop() private id!: number;
  @Prop({ default: false }) private hasSsn!: boolean;
  
  get ssnModified() {
    return this.originalSsn !== this.ssn
  }

  get placeholder() {
    if (this.hasSsn) {
      return ''.padStart(11, '\u25CF');
    }
    return '';
  }

  async toggleVisibility() {
    if (this.id && !this.ssn) {
      this.ssn = await restService.passengers.getSsn(this.id);
      this.originalSsn = this.ssn;
    }
    this.showSsn = !this.showSsn
  }

  async saveSsn() {
    if (this.ssnModified) {
      const result = await restService.passengers.setPassengerSsn(
        this.id,
        this.ssn
      );
      this.ssn = result;
      this.originalSsn = this.ssn;
      this.$store.commit('passenger/setHasSsnToPassenger', { passengerId: this.id, ssn: this.ssn });
    }
  }

  async saveSsnForNewPassenger(id: number, ssn: string) {
      const result = await restService.passengers.setPassengerSsn(id, ssn);
      this.ssn = result;
      this.$store.commit('passenger/setHasSsnToPassenger', { passengerId: id, ssn: this.ssn });
  }

  getSsnForNewPassenger() {
    if (this.isValidSsn) {
      return this.ssn;
    }
    return "";
  }

  isValidSsn(ssn: string) {
    if (!ssn) {
      this.valid = true;
      return true;
    } else if (ssn.length !== 11) {
      // Ssn should be 11 chars
      this.valid = false;
      return false;
    } else {
      const regex = /^(\d{2})(\d{2})(\d{2})([\+\-ABCDEFYXWVU])(\d{3})([0-9ABCDEFHJKLMNPRSTUVWXY])$/;
      const parts = this.ssn.match(regex);
      if (parts === null || parts.length !== 7) {
        // Did not match pattern
        this.valid = false;
        return false;
      } else {
        const num = parseInt(parts[1] + parts[2] + parts[3] + parts[5], 10);
        if (isNaN(num)) {
          // Cound not parse checksum number
          this.valid = true;
          return true;
        }

        const check = "0123456789ABCDEFHJKLMNPRSTUVWXY".split("")[num % 31];
        if (check !== parts[6].toUpperCase()) {
          // Last checksum mark is not correct, should be check
          this.valid = false;
          return false;
        }
        this.valid = true;
        return true;
      }
    }
  }
}
